import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {Company} from 'shared/models/target-groups/company';

@Injectable()
export class CompaniesRepository {

  constructor(private http: Http) { }

  public getAllCompanies(): Observable<Array<Company>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.companies}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllCompaniesUsersCnt(): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.usersCompany}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getCompany(id: String): Observable<Company> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.companies}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createCompany(company: Company): Observable<Company> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(company);

    return this.http.post(`${environment.targetGroups.companies}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateCompany(company: Company): Observable<Company> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(company);

    return this.http.put(`${environment.targetGroups.companies}/${company._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteCompany(company: Company): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.targetGroups.companies}/${company._id}`, options)
      .map((response: Response) => {
        return response.ok;
      });
  }

  public getUsersExport(company: Company): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      responseType: ResponseContentType.Blob,
    });

    const companyFilter: string = JSON.stringify([company._id]);

    return this.http.get(`${environment.usersExport}?companies=${companyFilter}`, options)
      .map((response: Response) => {
        return response.blob();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/companies/repositories/companies.repository.ts